import { render, staticRenderFns } from "./partners-type.vue?vue&type=template&id=1fc062d2&scoped=true"
import script from "./partners-type.ts?vue&type=script&lang=ts&external"
export * from "./partners-type.ts?vue&type=script&lang=ts&external"
import style0 from "./partners-type.scss?vue&type=style&index=0&id=1fc062d2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc062d2",
  null
  
)

export default component.exports